<template>
    <div class="videobox">
        <!-- <div v-if="channel" class="sumnaildiv" :style="`background-image: url(${getThumbnail(channel.utube_src)});`">
            <button class="inbut" @click="openYoutube(channel?.utube_src)">채널 입장</button>
            <p class="channelnum">LIVE&ensp;{{ number }}</p>
        </div> -->
        <div v-if="channel" class="movie sumnaildiv">
            <iframe :src="formatYoutubeEmbed(channel.utube_src)" frameborder="0" allowfullscreen></iframe>
        </div>
        <div v-if="!channel" class="sumnaildiv" style="background-image: url(/images/prepare.png);">
        </div>

        <!-- 채널정보 -->
        <div class="infodiv">
            <a v-if="channel" :href="channel.utube_src" target="_blank" rel="noopener noreferrer">
                <h4 class="channername">
                    {{ channel?.name || "헬로우아바타" }}
                </h4>
            </a>
            <h4 v-if="!channel" class="channername">
                {{ channel?.name || "헬로우아바타" }}
            </h4>
            <div>
                <h3> {{ channel?.title || "게임을 좋아한다면, 이 채널은 필수 시청!" }}</h3>
                <p class="subtext">
                    {{ channel?.description || "최신 인기 게임부터 숨겨진 명작까지! 플레이 실력은 기본, 꿀팁과 웃음까지 \
                    챙겨드립니다. 매주 업데이트되는 다채로운 게임 콘텐츠, 지금 구독!" }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>

defineProps({
    channel: Object,
    number: Number
})

// function getThumbnail(url) {
//     const match = url?.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/)
//     return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : '/images/prepare.png'
// }

// function openYoutube(url) {
//     if (url) window.open(url, "_blank");
// }

const formatYoutubeEmbed = (url) => {
    const reg = /(?:\?v=|\.be\/)([\w-]{11})/;
    const match = url.match(reg);
    const videoId = match ? match[1] : null;

    return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
}

</script>